import { render, staticRenderFns } from "./MainNavigationList.vue?vue&type=template&id=b05d1a4a"
import script from "./MainNavigationList.vue?vue&type=script&lang=js"
export * from "./MainNavigationList.vue?vue&type=script&lang=js"
import style0 from "./MainNavigationList.vue?vue&type=style&index=0&id=b05d1a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports